export const applyTerrainFilters = (annonce, filters) => {
  const {
    superficieMin,
    superficieMax,
    localisation = [],
    prixMin,
    prixMax,
  } = filters;

  return (
    (!superficieMin || annonce.superficie >= superficieMin) &&
    (!superficieMax || annonce.superficie <= superficieMax) &&
    (localisation.length === 0 || localisation.includes(annonce.localisation)) &&
    (!prixMin || annonce.prix >= prixMin) &&
    (!prixMax || annonce.prix <= prixMax)
  );
};
